import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = [
  "Internet très haut débit",
  "Téléphonie mobile",
  "TV et chaînes de sports",
  "Sans contrat",
  "Service client réactif",
  "Rabais à vie",
];

export const MarqueeStrip = () => (
  <div className="border-y border-black/5 bg-gray-50 py-5" data-testid="marquee-strip" aria-hidden="true">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="mx-6 flex items-center gap-6 font-display text-sm font-semibold uppercase tracking-[0.25em] text-gray-400">
          {item}
          <Asterisk className="h-4 w-4 text-jeem-yellow" strokeWidth={3} />
        </span>
      ))}
    </Marquee>
  </div>
);
